/**
 * Loading state (design_handoff §1g #1): row skeletons at the final row
 * height so nothing shifts when data arrives, plus an announced status for
 * screen readers rather than a silent spinner.
 */
export function TableSkeleton({ rows = 8, columns = 11 }: { rows?: number; columns?: number }) {
  return (
    <div className="table-wrap table-skeleton" aria-hidden="true">
      <table>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={rowIndex} className="skeleton-row">
              {Array.from({ length: columns }).map((_, columnIndex) => (
                <td key={columnIndex}>
                  <span
                    className="skeleton-block"
                    style={{ width: columnIndex === 0 ? '70%' : '85%' }}
                  />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
